import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpHandler } from '@angular/common/http';
import {
  API_BASE_URL,
  SessionServiceProxy,
  TokenAuthServiceProxy,
  FarmerServiceServiceProxy,
  CountyServiceServiceProxy,
  UserServiceProxy,
  CropServiceServiceProxy,
  NutrientSourceServiceServiceProxy,
  RegistrationTokenServiceServiceProxy,
  FarmerCountyServiceServiceProxy,
  FarmerCropQuantityServiceServiceProxy,
  FarmerNutrientSourceQuantityServiceServiceProxy,
  PasswordResetServiceServiceProxy,
  VVerificationServiceServiceProxy,
  VVerificationQuestionAnswerServiceServiceProxy,
  ManureStorageSourceServiceServiceProxy,
  ManureStorageDurationServiceServiceProxy,
  ManureStorageTypeServiceServiceProxy,
  FarmerManureStorageServiceServiceProxy,
  CostShareServiceServiceProxy,
  FarmerCostShareServiceServiceProxy,
  WatershedServiceServiceProxy,
  FarmerWatershedServiceServiceProxy,
  CertificationCategoryServiceServiceProxy,
  CertificationAnswerServiceServiceProxy,
  NMPTypeServiceServiceProxy,
  NutrientRecommendationServiceServiceProxy,
  FarmerNutrientRecommendationQuantityServiceServiceProxy,
  CertificationServiceServiceProxy,
  RoleServiceProxy,
  AccountServiceProxy,
  DashboardServiceServiceProxy,
  ExportServiceServiceProxy,
  VVerificationQuestionNoteServiceServiceProxy,
  SecurityQuestionServiceServiceProxy,
  UserSecurityQuestionAnswerServiceServiceProxy
} from '@shared/service-proxies/service-proxies';
import { AppConsts } from '@shared/AppConsts';
import { SharedModule } from '@shared/shared.module';
import { LoginPage } from './account/login/login.page';
import { HomePage } from './main/home/home.page';
import { LoginPageModule } from './account/login/login.module';
import { HomePageModule } from './main/home/home.module';
import { RegisterPage } from './account/register/register.page';
import { RegisterPageModule } from './account/register/register.module';
import { PasswordResetPage } from './account/password-reset/password-reset.page';
import { PasswordResetPageModule } from './account/password-reset/password-reset.module';
import { AppRouteGuard } from '@shared/auth/auth-route-guard';
import { AppSessionService } from '@shared/session/app-session.service';
import { HttpClientModule } from '@angular/common/http';
import { AppHttpInterceptor } from '@shared/app-http-interceptor';
import { AppPreBootstrap } from './AppPreBootstrap';
import { IonicStorageModule } from '@ionic/storage';
import { CertificationPageModule } from './main/certification/certification.module';
import { CertificationPage } from './main/certification/certification.page';
import { FarmerPageModule } from './main/farmer/farmer.module';
import { FarmersPageModule } from './main/farmers/farmers.module';
import { FarmerPage } from './main/farmer/farmer.page';
import { FarmersPage } from './main/farmers/farmers.page';
import { LogoutPage } from './account/logout/logout.page';
import { LogoutPageModule } from './account/logout/logout.module';
import { ManureStoragePage } from './main/farmer/manure-storage/manure-storage.page';
import { ManureStoragePageModule } from './main/farmer/manure-storage/manure-storage.module';
import { UsersPage } from './main/users/users.page';
import { UsersPageModule } from './main/users/users.module';
import { UserPage } from './main/user/user.page';
import { UserPageModule } from './main/user/user.module';
import { VerificationPage } from './main/verification/verification.page';
import { VerificationsPage } from './main/verifications/verifications.page';
import { VerificationPageModule } from './main/verification/verification.module';
import { VerificationsPageModule } from './main/verifications/verifications.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ionic4DatepickerModule } from '@logisticinfotech/ionic4-datepicker';
import { CertificationScorePage } from './main/certification-score/certification-score.page';
import { CertificationScorePageModule } from './main/certification-score/certification-score.module';
import { HelpDeskPage } from './main/help-desk/help-desk.page';
import { HelpDeskPageModule } from './main/help-desk/help-desk.module';
import { HelpDeskService } from '@shared/help-desk/help-desk.service';
import { DashboardPageModule } from './main/dashboard/dashboard.module';
import { ExportService } from '@shared/export/export.service';
import { Globals } from './app.globals';
import { ProfilePage } from './main/farmers/profile/profile.page';
import { ProfilePageModule } from './main/farmers/profile/profile.module';
import { VerificationQuestionNotePage } from './main/verification/verification-question-note/verification-question-note.page';
import { VerificationQuestionNotePageModule } from './main/verification/verification-question-note/verification-question-note.module';
import { SecurityQuestionPage } from './account/register/security-question/security-question.page';
import { SecurityQuestionPageModule } from './account/register/security-question/security-question.module';
import { CertificationValidationPage } from './main/certification/certification-validation/certification-validation.page';
import { CertificationValidationPageModule } from './main/certification/certification-validation/certification-validation.module';
import { AdminPage } from './main/admin/admin.page';
import { AdminPageModule } from './main/admin/admin.module';
import { PrivacyPage } from './main/privacy/privacy.page';
import { PrivateDataPage } from './main/privacy/private-data.page';
import { PrivacyPageModule } from './main/privacy/privacy.module';

export function getRemoteServiceBaseUrl(): string {
  return AppConsts.remoteServiceBaseUrl;
}

export function init_app(appbootstrap: AppPreBootstrap) {
  return () => appbootstrap.run(AppConsts.remoteServiceBaseUrl, null);
}
@NgModule({
  declarations: [AppComponent],
  entryComponents: [
    LoginPage,
    HomePage,
    RegisterPage,
    SecurityQuestionPage,
    PasswordResetPage,
    CertificationPage,
    CertificationValidationPage,
    CertificationScorePage,
    FarmerPage,
    FarmersPage,
    ProfilePage,
    LogoutPage,
    ManureStoragePage,
    UsersPage,
    UserPage,
    VerificationPage,
    VerificationsPage,
    VerificationQuestionNotePage,
    HelpDeskPage,
    AdminPage,
    PrivacyPage,
    PrivateDataPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    SharedModule.forRoot(),
    LoginPageModule,
    HomePageModule,
    RegisterPageModule,
    SecurityQuestionPageModule,
    PasswordResetPageModule,
    CertificationPageModule,
    CertificationValidationPageModule,
    CertificationScorePageModule,
    FarmerPageModule,
    FarmersPageModule,
    ProfilePageModule,
    LogoutPageModule,
    ManureStoragePageModule,
    UsersPageModule,
    UserPageModule,
    VerificationPageModule,
    VerificationsPageModule,
    VerificationQuestionNotePageModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    NgxDatatableModule,
    FormsModule,
    ReactiveFormsModule,
    Ionic4DatepickerModule,
    HelpDeskPageModule,
    DashboardPageModule,
    AdminPageModule,
    PrivacyPageModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AppRouteGuard,
    AppSessionService,
    AccountServiceProxy,
    SessionServiceProxy,
    HttpClient,
    TokenAuthServiceProxy,
    FarmerServiceServiceProxy,
    CountyServiceServiceProxy,
    CropServiceServiceProxy,
    NutrientSourceServiceServiceProxy,
    RegistrationTokenServiceServiceProxy,
    FarmerCountyServiceServiceProxy,
    FarmerCropQuantityServiceServiceProxy,
    FarmerNutrientSourceQuantityServiceServiceProxy,
    PasswordResetServiceServiceProxy,
    VVerificationServiceServiceProxy,
    VVerificationQuestionAnswerServiceServiceProxy,
    VVerificationQuestionNoteServiceServiceProxy,
    ManureStorageSourceServiceServiceProxy,
    ManureStorageDurationServiceServiceProxy,
    ManureStorageTypeServiceServiceProxy,
    FarmerManureStorageServiceServiceProxy,
    CostShareServiceServiceProxy,
    FarmerCostShareServiceServiceProxy,
    WatershedServiceServiceProxy,
    FarmerWatershedServiceServiceProxy,
    CertificationCategoryServiceServiceProxy,
    CertificationAnswerServiceServiceProxy,
    NMPTypeServiceServiceProxy,
    NutrientRecommendationServiceServiceProxy,
    FarmerNutrientRecommendationQuantityServiceServiceProxy,
    CertificationServiceServiceProxy,
    RoleServiceProxy,
    UserServiceProxy,
    SecurityQuestionServiceServiceProxy,
    UserSecurityQuestionAnswerServiceServiceProxy,
    Storage,
    AppPreBootstrap,
    HelpDeskService,
    DashboardServiceServiceProxy,
    ExportServiceServiceProxy,
    ExportService,
    Globals,
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: APP_INITIALIZER, useFactory: init_app, deps: [AppPreBootstrap], multi: true }
  ],
  bootstrap: [AppComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
